import { Box, Card, useTheme } from "@mui/material"

const BoxCard = props => {
  const { sx = {}, shadow = 0, children, ...others } = props
  const theme = useTheme()

  return (
    <Card
      sx={{
        position: "relative",
        p: 0,
        height: 150,
        border: `1px solid ${theme.palette.grey[100]}`,
        boxShadow: theme.shadows[shadow],
        borderRadius: "22px",
        "&:hover": {
          boxShadow: theme.shadows[2]
        },
        ...sx
      }}
      {...others}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: `url('/images/layer-pattern.png') no-repeat center center / cover`,
          opacity: 0.5
        }}
      />
      <Box sx={{ position: "relative", zIndex: 1 }}>{children}</Box>
    </Card>
  )
}

export default BoxCard
